export enum UserCurrencyEnums {
  US_DOLLAR = 'USD',
  EURO = 'EUR',
  BITCOIN = 'BTC',
  SATOSHI = 'SATS',
}
